import { render, staticRenderFns } from "./TileHeader.vue?vue&type=template&id=bd068148&scoped=true&"
import script from "./TileHeader.vue?vue&type=script&lang=js&"
export * from "./TileHeader.vue?vue&type=script&lang=js&"
import style0 from "./TileHeader.vue?vue&type=style&index=0&id=bd068148&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd068148",
  null
  
)

export default component.exports